import {
  IElementCategory,
  ElementCategoryID,
} from '../../../models/element-categories.model';
import {
  DEFAULT_AREAL_DENSITY_PROPERTIES,
  DEFAULT_QUANTITY_PROPERTIES,
} from '../../../models/element-quantities.model';
import {
  getElementPropertySelectionByValue,
  getValueFromConditionalNodes,
} from '../../../helpers/conditional-nodes.helpers';
import { ceramicsProperties } from './ceramics-properties';
import { conditionalCeramicsProductIds } from './ceramics-product-ids';
import { ProductID } from '../../../models/product.model';

export const ceramics: IElementCategory = {
  id: ElementCategoryID.Ceramics,
  name: 'Ceramics',
  color: '#D0966D',
  defaultSelectedQuantity: 'mass',
  properties: ceramicsProperties,

  getQuantityProperties: () => ({
    ...DEFAULT_QUANTITY_PROPERTIES,
    ...DEFAULT_AREAL_DENSITY_PROPERTIES,
  }),

  // `throwIfNotFound: false` + `undefined` passthrough: a proposal-scoped
  // edit can leave a driving Select in a transient state that the conditional
  // tree cannot map (e.g. a stale option after a template change). Throwing
  // would crash the enrich pass; `undefined` tells the caller to skip
  // enrichment and preserve existing children (see metal.ts comment).
  getChildElements: (element) =>
    getValueFromConditionalNodes(
      element,
      [conditionalCeramicsProductIds],
      false,
    ),

  getElementPropertySelectionByProductId: (productId: ProductID) =>
    getElementPropertySelectionByValue(
      productId,
      conditionalCeramicsProductIds,
    ),
};
